let loadMore= {

      bind(el, binding) {
    
        var p = 0;
    
        var t = 0;
    
        var down = true;
    
        var selectWrap = el.querySelector('.el-table__body-wrapper')
    
        selectWrap.addEventListener('scroll', function() {
    
          //判断是否向下滚动
    
          p = this.scrollTop;
    
          // if ( t < p){down=true}else{down=false}
    
          if(t < p){
    
            down = true;
    
          }else{
    
            down = false;
    
          }
    
          t = p;
    
          //判断是否到底
    
          const sign = 10;
    
          const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight
    
          if (scrollDistance <= sign && down) {
    
            binding.value()
    
          }
    
        })
    
      }
    
    }
    export default loadMore


// WEBPACK FOOTER //
// ./src/directives/src/loadMore.js